// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2upKA","selected":"styles_selected__3otGI"};